import { useEffect } from "react";

export const REFRESH_EVENT = "trt:refresh";
export const dispatchRefresh = () => window.dispatchEvent(new CustomEvent(REFRESH_EVENT));

// Páginas recarregam dados sem remontar (preserva formulários/modais abertos).
export const useRefreshListener = (fn) => {
  useEffect(() => {
    const h = () => { if (!document.querySelector("[role=dialog]")) fn(); };
    window.addEventListener(REFRESH_EVENT, h);
    return () => window.removeEventListener(REFRESH_EVENT, h);
  }, [fn]);
};

// Formato financeiro: zero real → "R$ 0,00"; ausente/erro → "—" (nunca mascara dado faltante como zero)
export const brlOrDash = (v) => (v === null || v === undefined || v === "" || Number.isNaN(Number(v)))
  ? "—" : "R$ " + Number(v).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const waLink = (telefoneNormalizado, texto) => telefoneNormalizado ? `https://wa.me/${telefoneNormalizado}?text=${encodeURIComponent(texto || "")}` : "";

// Validação de identificação (mesma regra do backend): CPF 11 dígitos válido (zeros iniciais preservados) e nascimento real, não futura
export const cpfValido = (v) => { const d = (v || "").replace(/\D/g, ""); if (d.length !== 11 || /^(\d)\1{10}$/.test(d)) return false; for (const n of [9, 10]) { let s = 0; for (let i = 0; i < n; i++) s += Number(d[i]) * (n + 1 - i); if ((s * 10) % 11 % 10 !== Number(d[n])) return false; } return true; };
export const nascimentoValido = (v) => { if (!/^\d{4}-\d{2}-\d{2}$/.test(v || "")) return false; const d = new Date(v + "T12:00:00"); return !Number.isNaN(d) && d.toISOString().slice(0, 10) === v && v <= new Date().toISOString().slice(0, 10) && Number(v.slice(0, 4)) >= 1900; };
export const erroIdentificacao = (cpf, nasc) => !cpfValido(cpf) ? "Informe um CPF válido (11 dígitos)." : !nascimentoValido(nasc) ? "Informe uma data de nascimento válida (não futura)." : "";
